<template>
<div>
    <div class="col-md-12">
        <div class="row" style="margin-top: 20px">
            <div class="col-md-6" v-if="!embedded">
                <h3 class="page-header">
                    <i class="fa fa-undo animated bounceInDown show-info"></i>
                    <span>Receive Rejected Orders</span>
                </h3>
            </div>
            <div class="text-right" :class="embedded ? 'col-md-12' : 'col-md-6'">
                <button @click="refresh()" class="btn btn-refresh"><i class="fa fa-refresh"></i></button>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-body flex-between-row">
                <div>
                    <button class="btn btn-sm" :class="received == 0 ? 'btn-primary' : 'btn-default'" @click="setTab(0)">To Receive</button>
                    <button class="btn btn-sm" :class="received == 1 ? 'btn-primary' : 'btn-default'" @click="setTab(1)">Received</button>
                </div>
                <div class="flex-row">
                    <input class="form-control input-small" v-model="search" type="text"
                        placeholder="Customer name / mobile / order no." @keyup.enter="refresh()" style="width:260px"/>
                    <button class="btn btn-primary btn-sm" @click="refresh()">Search</button>
                </div>
                <div>
                    <span class="control-label">Total:</span>
                    <span class="badge bg-danger">{{ count }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <p class="text-muted" v-if="received == 0">
            The delivery boy brings the product back to the shop; the employee who dispatched the order
            (or an admin) receives it here. An admin then verifies and disposes the order from its conversation.
        </p>
        <div class="panel">
            <div class="table-responsive panel-body">
                <table class="table users-table table-condensed table-hover table-bordered table-sm">
                    <thead class="table-font" style="font-size:13px;">
                        <tr>
                            <th>#</th>
                            <th>Order No.</th>
                            <th>Customer</th>
                            <th>Mobile</th>
                            <th>Address</th>
                            <th>Product</th>
                            <th>Delivery Boy</th>
                            <th>Rejected On / Reason</th>
                            <th v-if="received == 0">Receive</th>
                            <th v-else>Received By</th>
                        </tr>
                    </thead>
                    <tbody class="table-font" style="font-size:13px;">
                        <tr v-if="!loading && orders.length == 0">
                            <td colspan="9" class="text-center">No orders here</td>
                        </tr>
                        <tr v-for="(item, index) in orders" :key="item.id">
                            <td>{{ (currentpage - 1) * noofrec + index + 1 }}</td>
                            <td>{{ item.complaintno }}<br>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
                            <td>
                                <span v-if="item.customer">{{ item.customer.name }}<br>{{ item.customer.generatedid }}</span>
                                <span v-else>{{ item.customername }}</span>
                            </td>
                            <td>
                                <display-mobiles v-if="item.customer" :mobiles="item.customer.mobiles"></display-mobiles>
                                <span v-else>{{ item.customermobile }}</span>
                            </td>
                            <td>
                                <display-first-address v-if="item.customer" :addresses="item.customer.addressess"></display-first-address>
                                <span v-else>{{ item.customeraddress }}</span>
                            </td>
                            <td>{{ item.product?.category?.name }} {{ item.product?.name }}</td>
                            <td>
                                {{ item.deliveryboy?.name || '-' }}
                                <div style="font-size:11px">Dispatched by: {{ item.followby?.name || '-' }}</div>
                            </td>
                            <td>
                                {{ moment(item.updated_at).format('DD-MM-YYYY hh:mm A') }}
                                <div style="color:#c0392b">{{ item.updatedremark }}</div>
                            </td>
                            <td v-if="received == 0" style="min-width:220px">
                                <div v-if="!canReceive(item)" style="color:#999">
                                    Only {{ item.followby?.name || 'the employee who dispatched it' }} (or an admin) can receive this.
                                </div>
                                <div v-else>
                                    <input class="form-control input-small" v-model="remarks[item.id]" type="text"
                                        placeholder="Condition / remark (optional)"/>
                                    <button class="btn btn-success btn-xs" style="margin-top:4px"
                                        :disabled="savingid == item.id" @click="receive(item)">
                                        {{ savingid == item.id ? 'Saving...' : 'Receive Product' }}
                                    </button>
                                </div>
                            </td>
                            <td v-else>
                                <span style="color:green;font-weight:600">{{ item.returnreceivedby?.name }}</span><br>
                                {{ item.return_receivedat ? moment(item.return_receivedat).format('DD-MM-YYYY hh:mm A') : '' }}
                                <div>{{ item.return_remark }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <nav style="text-align: right" v-if="noofpages > 1">
            <paginate style="margin: 0px !important; float: right" :page-count="noofpages"
                :click-handler="clickCallback" :prev-text="'&laquo;'" :next-text="'&raquo;'"
                :container-class="'pagination'"></paginate>
        </nav>
    </div>
</div>
</template>
<script>
import moment from 'moment'
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex'
import Constants from '../../components/utilities/Constants.vue'
import DisplayFirstAddress from '../../components/address/DisplayFirstAddress.vue'
import DisplayMobiles from '../../components/mobile/DisplayMobiles.vue'
export default {
    // embedded: shown as a tab of Dispatch & Returns (no page title)
    props: { embedded: { type: Boolean, default: false } },
    mixins: [Constants],
    components: { Paginate, DisplayFirstAddress, DisplayMobiles },
    data() {
        return {
            moment: moment,
            orders: [],
            count: 0,
            received: 0,
            search: '',
            currentpage: 1,
            noofrec: 50,
            loading: false,
            savingid: null,
            remarks: {}
        }
    },
    computed: {
        ...mapGetters(['loggedinuser']),
        noofpages() {
            return Math.ceil(this.count / this.noofrec)
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        setTab(received) {
            this.received = received
            this.currentpage = 1
            this.refresh()
        },
        clickCallback(page) {
            this.currentpage = page
            this.refresh()
        },
        refresh() {
            this.loading = true
            this.$store.commit('assignloadingstatus', 1)
            this.$http.post('api/vsdigi/leads/orders/returns', {
                received: this.received, search: this.search,
                currentpage: this.currentpage, noofrec: this.noofrec
            })
                .then((response) => {
                    this.orders = response.data.orders || []
                    this.count = response.data.count || 0
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to load orders', type: 'error' })
                })
                .finally(() => {
                    this.loading = false
                    this.$store.commit('assignloadingstatus', 0)
                })
        },
        // the employee who dispatched the order, or an admin (same as the backend)
        canReceive(item) {
            if (this.loggedinuser == null) return false
            return this.loggedinuser.role > 1 || (item.followedid > 0 && item.followedid == this.loggedinuser.id)
        },
        receive(item) {
            if (!confirm('Confirm the product of this order has been received back at the shop?')) return
            this.savingid = item.id
            this.$http.post('api/vsdigi/leads/orders/returns/receive', { id: item.id, remark: this.remarks[item.id] || '' })
                .then(() => {
                    this.$notify({ text: 'Product received, marked as returned', type: 'success' })
                    this.refresh()
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to receive the product', type: 'error' })
                })
                .finally(() => {
                    this.savingid = null
                })
        }
    }
}
</script>
